import React from 'react';
import { Grid, Typography, Button, makeStyles, MenuItem, Divider, TextField } from '@material-ui/core';
import OutlinedSelect from '../../../../controls/OutlinedSelect';
import ConditionTable from '../ConditionTable';
import { basicConditionBlank } from '../../fieldDialogLogic';
import { checkComplexConditions } from '../../fieldDialogLogic';

const useStyles = makeStyles((theme) => ({
    emptyRule: {
        marginTop: theme.spacing(3),
    },
}));

const addFirstCondition = (changeConditions) => {
    const newConditions = [basicConditionBlank];
    const event = {
        target: {
            name: 'conditions',
            value: newConditions,
        },
    };
    changeConditions(event);
};

const deleteAllConditions = (changeConditions) => {
    const newConditions = [];
    const event = {
        target: {
            name: 'conditions',
            value: newConditions,
        },
    };
    changeConditions(event);
};

const handleChangeAdvanced = ({ target: { value } }, changeVisibility) => {
    let advancedRequiredMsg = null;
    try {
        let conditions = JSON.parse(value);
        advancedRequiredMsg = checkComplexConditions(conditions)
            ? 'The conditions are too complex to display in basic mode'
            : null;
    } catch (e) {
        if (value === '') {
            deleteAllConditions(changeVisibility);
        } else {
            advancedRequiredMsg = 'The information you have entered is not valid JSON';
        }
    }

    const conditionsEvent = {
        target: {
            name: 'advancedVisibility',
            value,
        },
    };
    changeVisibility(conditionsEvent);

    const msgEvent = {
        target: {
            name: 'advancedRequiredMsg',
            value: advancedRequiredMsg,
        },
    };
    changeVisibility(msgEvent);
};

export default function Conditions(props) {
    const classes = useStyles();

    if (props.advancedMode) {
        return (
            <React.Fragment>
                <Grid item xs={12}>
                    <Typography variant="body1">Enter field rule in JSON format</Typography>
                    <TextField
                        id={'advanced-visibility'}
                        label="Rules"
                        multiline
                        variant="outlined"
                        rows="8"
                        defaultValue={props.advancedVisibility}
                        onChange={(event) => handleChangeAdvanced(event, props.handleChange)}
                        margin="normal"
                        fullWidth
                    />
                </Grid>
            </React.Fragment>
        );
    } else {
        if (!props.conditions.length) {
            return (
                <React.Fragment>
                    <Grid
                        container
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        spacing={2}
                        className={classes.emptyRule}
                    >
                        <Grid container item direction="column" justifyContent="center" alignItems="center">
                            <Grid>
                                <Typography variant="body1">No conditions have been added for this field.</Typography>
                            </Grid>
                            <Grid>
                                <Typography variant="body1">This field is always visible.</Typography>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Button onClick={() => addFirstCondition(props.handleChange)} color="primary">
                                Add a Condition
                            </Button>
                        </Grid>
                    </Grid>
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <Grid container direction="column" spacing={3}>
                        <Grid xs={12} container item alignItems="center" justifyContent="space-between">
                            <Grid container xs={9} item spacing={1} alignItems="center">
                                <Grid item>
                                    <Typography component={'span'}>Show this field if</Typography>
                                </Grid>
                                <Grid item>
                                    <OutlinedSelect
                                        name="booleanOperator"
                                        fullWidth={false}
                                        margin="dense"
                                        variant="outlined"
                                        id={'boolean-operator'}
                                        value={props.operator}
                                        onChange={props.handleChange}
                                    >
                                        <MenuItem value={'any'}>{'Any'}</MenuItem>
                                        <MenuItem value={'all'}>{'All'}</MenuItem>
                                    </OutlinedSelect>
                                </Grid>
                                <Grid item>
                                    <Typography>of the following conditions are met:</Typography>
                                </Grid>
                            </Grid>
                            <Grid item>
                                <Button color="primary" onClick={() => deleteAllConditions(props.handleChange)}>
                                    Clear All
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                        <Grid></Grid>
                        <Grid item xs={12}>
                            <ConditionTable
                                conditions={props.conditions}
                                entries={props.entries}
                                ruleIndex={0}
                                booleanOperator={props.operator}
                                handleRuleChange={props.handleChange}
                            />
                        </Grid>
                    </Grid>
                </React.Fragment>
            );
        }
    }
}
